

function detectmob() {

    if( navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
    ){

        // If mobile, then we do all this
        jQuery('.home-intro__video').hide();
    }
    else {

        // If not mobile then do this
        // jQuery('.home-intro__video').attr('preload','auto').attr('autoplay','autoplay');

    }
}
detectmob();






//Parrallaxorama-mama
// jQuery(this).on('load scroll',function() {
//     myTop = jQuery(this).scrollTop();
//     // console.log(myTop);
//     if(myTop > 1){
//         jQuery('.home-intro__header').fadeOut();
//         jQuery('body.home .site-header-container').fadeIn();
//         // jQuery('html, body').animate({ scrollTop: '1067px' }, 500);
//     } else {
//         jQuery('.home-intro__header').fadeIn();
//         jQuery('body.home .site-header-container').fadeOut();
//     }
// });



// var homeHeader = jQuery('.home-intro__header');
// var siteHeader = jQuery('body.home .site-header-container');
// jQuery(window).on('load scroll',function() {
//     myTop = jQuery(this).scrollTop();
//     if(myTop > 0){
//         homeHeader.stop().fadeOut(200);
//         siteHeader.stop().css({ visibility: "visible" }).fadeTo(200, 1);
//     } else {
//         homeHeader.stop().fadeIn(200);
//         siteHeader.stop().fadeTo(200, 0, function () {
//             siteHeader.css({ visibility: "hidden" });
//         });
//     }
// });





//  Used on the homepage to hide/show the sticky header and the home header
// var siteHeader = jQuery('body.home .site-header');
// var homeHeader = jQuery('.home-intro__header');
// var fired = false;
// jQuery(window).on('load scroll',function() {
//     myTop = jQuery(this).scrollTop();
//     if(myTop > 216  && !fired){
//         // siteHeader.css({opacity:1});
//         // homeHeader.css({opacity:0});
//         siteHeader.addClass('is-visible');
//         homeHeader.addClass('is-hidden');
//         fired = true;
//     } else if(myTop <= 216  && fired) {
//         // siteHeader.css({opacity:0});
//         // homeHeader.css({opacity:1});
//         siteHeader.removeClass('is-visible');
//         homeHeader.removeClass('is-hidden');
//         fired = false;
//     }
// });





// Defer loading the Youtube vids on the homepage to improve page load
// function init() {
// var vidDefer = document.getElementsByTagName('iframe');
// for (var i=0; i<vidDefer.length; i++) {
// if(vidDefer[i].getAttribute('data-src')) {
// vidDefer[i].setAttribute('src',vidDefer[i].getAttribute('data-src'));
// } } }
// window.onload = init;







// Lazyload YouTube videos
// https://webdesign.tutsplus.com/tutorials/how-to-lazy-load-embedded-youtube-videos--cms-26743
// <div class="youtube" data-embed="AqcjdkPMPJA">
//     <div class="play-button"></div>
// </div>
( function() {

    var youtube = document.querySelectorAll( ".youtube" );

    for (var i = 0; i < youtube.length; i++) {

        // var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/hqdefault.jpg";
        var source = "https://img.youtube.com/vi/"+ youtube[i].getAttribute('data-embed') +"/hqdefault.jpg";

        var image = new Image();
                image.src = source;
                image.addEventListener( "load", function() {
                    youtube[ i ].appendChild( image );
                }( i ) );

                youtube[i].addEventListener( "click", function() {

                    var iframe = document.createElement( "iframe" );

                            iframe.setAttribute( "frameborder", "0" );
                            iframe.setAttribute( "allowfullscreen", "" );
                            // iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?rel=0&showinfo=0&autoplay=1" );
                            iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.getAttribute('data-embed') +"?rel=0&showinfo=0&autoplay=1" );

                            this.innerHTML = "";
                            this.appendChild( iframe );
                } );
    }

} )();







// Points of Interest

jQuery('.product-poi__container .product-poi__marker').hover(function(){
    var markerContainer = jQuery(this).parent('.product-poi__item');
    var markerContent = jQuery(this).siblings('.product-poi__content');

    // Add class to marker container so that it is above the other markers
    markerContainer.addClass('is-top-z');
    // Show the content by removing the "hide" class
    markerContent.removeClass('hide');

    // Add off-screen class if needed
    if( markerContent.is(':off-right') ) {
        markerContent.addClass('is-off-right');
    }

}, function() {
    var markerContainer = jQuery(this).parent('.product-poi__item');
    var markerContent = jQuery(this).siblings('.product-poi__content');

    // Remove "is-top-z" class
    markerContainer.removeClass('is-top-z');
    // Hide content, and remove off-screen class
    markerContent.addClass('hide').removeClass('is-off-right');
});




// Toggle the POI Groups

jQuery('.product-poi__group').not(":first").addClass('hide');
jQuery('.product-poi__toggler a').first().removeClass('secondary');

jQuery('.product-poi__toggler a').on('click', function(){
    var poiGroupIndex = jQuery(this).index();
    // jQuery(this).addClass('active').siblings().removeClass('active');
    jQuery(this).removeClass('secondary').siblings().addClass('secondary');
    jQuery('.product-poi__group:eq('+poiGroupIndex+')').removeClass('hide').siblings('.product-poi__group').addClass('hide');
    return false;
});





jQuery('.new-product-gallery__slider').slick({
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 3,
    variableWidth: true,
    arrows: true,
    speed: 500,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 3
            }
        },
        {
            breakpoint: 480,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1,
                dots: true
            }
        }
    ]
});


const searchIcon = document.querySelector(".site-search__icon");
const searchFormWrap = document.querySelector(".site-search__form");
const searchFormInput = searchFormWrap.querySelector(".aws-search-field");
const searchFormButton = searchFormWrap.querySelector('.button');

// Close search field if user clicks out of search box
document.addEventListener('mouseup', function (event) {
	if(event.target == searchIcon || event.target == searchFormWrap || event.target == searchFormInput) {
		event.preventDefault();
	} else {
		searchIcon.classList.remove('active');
		searchFormWrap.classList.remove('active');
	}
});

// Open Search field
searchIcon.addEventListener('click', function(event) {
	event.preventDefault();
	if(searchIcon.classList.contains('active')) {
		searchIcon.classList.remove('active');
		searchFormWrap.classList.remove('active');
	} else {
		searchIcon.classList.add('active');
		searchFormWrap.classList.add('active');
		searchFormInput.focus();
	}
});